import React, {FunctionComponent, useCallback, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {Button, Intent, Position, Toaster,} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

import {loadDatabaseSharingSettings} from '../../../store/actions/databaseActions';
import SharingSettingsDialog from './SharingSettingsDialog';
import {Entity} from './types';
import {getEntityType} from './utils';
import {ENTITY_TYPE} from './constants';
import {loadSharingSettings} from '../../../store/actions/sharingSettingsActions';

interface SharingSettingsButtonProps {
  entity: Entity;
}

const sharingSettingsToaster = Toaster.create({
  position: Position.TOP
});

const SharingSettingsButton: FunctionComponent<SharingSettingsButtonProps> = ({
  entity,
}: SharingSettingsButtonProps) => {
  const [shared, setShared] = useState(false);
  const [show, setShow] = useState(false);
  const [sharingSettingsIcon, setSharingSettingsIcon] = useState<any>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    let type = entity?.sharing_settings?.type || 'everyone';

    switch (type) {
      case 'everyone':
        setSharingSettingsIcon(IconNames.OFFICE);
        break;
      case 'shared':
        setSharingSettingsIcon(IconNames.PEOPLE);
        break;
      case 'private':
        setSharingSettingsIcon(IconNames.LOCK);
        break;
      }
  }, [entity]);

  const onClick = useCallback(() => {
    setShow(!show);
  }, [show]);

  const onClose = useCallback(() => {
    setShow(false);

    if (shared) {
      // if any share action happened, show a toast message after sharing settings modal was closed
      sharingSettingsToaster.show({
        message: "Sharing settings successfully updated.",
        intent: Intent.SUCCESS
      });

      const _type = getEntityType(entity);
      dispatch(loadSharingSettings(_type as any, entity.uid as string));
      setShared(false);
    }
  }, [shared]);

  const onShare = useCallback(() => {
    /*
     * if any share action happened, set shared to true
     */
    if (!shared) {
      setShared(true);
    }
  }, [shared]);

  return (
    <>
      <Button
        text="Share"
        fill={false}
        minimal={true}
        icon={sharingSettingsIcon}
        onClick={onClick}
      />
      {
        show && (
          <SharingSettingsDialog
            show={show}
            onClose={onClose}
            onShare={onShare}
            entity={entity}
          />
        )
      }
    </>
  )
};

export default SharingSettingsButton;
